export const decodeBase64OrDefault = <D = undefined>(str: string, def?: D): string | D => {
  if (str === '') {
    return def ? def : '';
  }
  try {
    // Check if running in Node.js environment
    if (typeof Buffer !== 'undefined') {
      const decoded = Buffer.from(str, 'base64').toString('utf-8');
      // Verify it was actually base64 by checking if re-encoding matches
      if (Buffer.from(decoded, 'utf-8').toString('base64') === str) {
        return decoded;
      }
    } else if (typeof atob !== 'undefined') {
      // Browser environment
      const decoded = atob(str);
      // Verify it was actually base64 by checking if re-encoding matches
      if (btoa(decoded) === str) {
        return decoded;
      }
    }
  } catch {
    // If decoding fails, return original string
  }

  if (!def) {
    return str;
  }

  return def as D;
};
